import PropTypes from 'prop-types';
import React from 'react';
import styles from './Modal.less';
import SvgX from '@wix/restaurants-components-css-modules/dist/svg/X/SvgX';
import ScrollBreak from './ScrollBreak';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';
import { MODAL_A11Y_IDS } from '../../../shared/constants';
import { isPremium } from '../../utils/ReservationHelpers';

export default ScrollBreak(ContentConnector({prefix: ''})(class extends React.Component {
    static displayName = 'Modal';

    static propTypes = {
        onClose: PropTypes.func,
        className: PropTypes.string,
        fullScreen: PropTypes.bool,
        isFreemium: PropTypes.bool,
        isCustomDesign: PropTypes.bool,
        XDimension: PropTypes.number,
        marginTop: PropTypes.number,
        onCloseShiftFocus: PropTypes.func,
        closeButtonRef: PropTypes.func,
        keepModalStateOpen:PropTypes.bool
    };

    static defaultProps = {
        onClose: () => {},
        className: '',
        fullScreen: false,
        isFreemium: false,
        XDimension: 16,
        marginTop: 0,
        onCloseShiftFocus: () => {},
        closeButtonRef: () => {}
    };

    constructor(props) {
        super(props);
        this.isPremium = isPremium(props.restaurant);
        this.isPreview = Wix.Utils.getViewMode() === 'preview';
        this.isMobile = Wix.Utils.getDeviceType() === 'mobile';
        this.state = {showModal: false };
    }

    componentDidMount() {
        setTimeout(() => {
            $(document).on('keyup', this._onKeyUp);
            window.focus();
            this.setState({showModal: true});
        }, 100);
    }

    componentWillUnmount() {
        $(document).off('keyup', this._onKeyUp);
    }

    render() {
        const { className, XDimension, marginTop, content, closeButtonRef, isPreview } = this.props;
        const wrapperClassNames = this._getClassNames();
        const isPreviewFreemium = isPreview && !this.isPremium;
        return (
            <div className={wrapperClassNames}>
                <div ref={this.setScrollTarget}
                     className={`${styles.stage} ${className}`}
                     style={{marginTop}}
                     aria-labelledby={MODAL_A11Y_IDS.TITLE_ID}
                     aria-describedby={MODAL_A11Y_IDS.DESCRIPTION_ID}
                     role="dialog">
                    <div className={`${styles.closeButton} reservation-modal-close-btn ${isPreviewFreemium ?styles.isPreviewFree:''}`}
                         data-hook="close"
                         onClick={this._closeModal}
                         aria-label={content.get('modal_close')}
                         tabIndex="0"
                         role="button"
                         ref={closeButtonRef}
                         onKeyDown={this._onCloseKeyDown}>
                        <SvgX shapeRendering="initial" width={XDimension} height={XDimension}/>
                    </div>
                    {React.Children.only(this.props.children)}
                </div>
            </div>
        );
    }

    _onCloseKeyDown = (e) => {
        const { onCloseShiftFocus } = this.props;
        const key = e.which;

        switch (key) {
            case 9: // tab
                if (e.shiftKey) {
                    onCloseShiftFocus();
                    e.preventDefault();
                }
                break;
            case 13: //space
            case 32: //enter
                e.preventDefault();
                this._closeModal();
                break;
        }
    };

    _getClassNames = () => {
        const { isCustomDesign, fullScreen } = this.props;
        const { showModal } = this.state;
        const restrictWidth = this.isPreview && this.isMobile;
        return `${styles.backdrop} ${showModal ?  styles.show : ''} ${fullScreen ? styles.fullScreen : ''} ${restrictWidth ? styles.restrict : ''} ${isCustomDesign ? styles.custom : ''}`;
    };

    setScrollTarget = (node) => {
        this.props.scrollBreak.registerTarget(node);
    };

    _closeModal = () => {
        const { onClose,keepModalStateOpen =false} = this.props;
        onClose();
        if(!keepModalStateOpen){
            this.setState({showModal: false});
        }

    };

    _onKeyUp = (e = window.event) => {
        if (this.state.showModal) {
            let isEsc = false;

            if ('key' in e) {
                isEsc = (e.key === 'Escape' || e.key === 'Esc');
            } else {
                isEsc = (e.keyCode === 27);
            }

            if (isEsc) {
                this._closeModal();
            }
        }
    };
}));
